// libs
import { produce } from "immer";
import { ActionTypes } from "./actions";
import { IAction, AppState, IHeaderOptions } from "./types";
import { APP_CONTEXT } from "shared/constants";
import get from "lodash/get";

export let initialState: AppState;

const initialHeaderState: IHeaderOptions = {
    showDiscount: true,
    showHamburger: true,
    showBack: false,
    showLogo: true,
    showSearch: true,
    showCart: true,
    headerMerge: false,
};

const connectApp = (ssrHeaders = {}, cookies = {}) => {
    initialState = Object.freeze<AppState>({
        statusCode: 200,
        headerOptions: {
            ...initialHeaderState,
        },
        headerDiscount: "",
        menu: {
            isFetching: true,
            isError: false,
            data: [],
        },
        user: {
            isFetching: true,
            isError: false,
            cartCount: 0,
            customerData: null,
            formKey: "",
            hasOptedForNewsletter: "",
            base_location: "",
        },
        inProgress: false,
        showHeader: true,
        ssrHeaders,
        cookies,
        webAppType: APP_CONTEXT.WEB,
        showLoginOption: false,
        searchTerm: "",
        baseCountry: get(ssrHeaders, "x-base-country-code", ""),
    });

    return (state: AppState = initialState, action: IAction): AppState =>
        produce(state, draft => {
            const { type, payload } = action;

            switch (type) {
                case ActionTypes.SET_HEADER_OFFER: {
                    draft.headerDiscount = payload;
                    return;
                }

                case ActionTypes.FETCH_HEADER_OFFER_FAILED: {
                    draft.headerDiscount = "";
                    return;
                }

                case ActionTypes.FETCH_MENU_PROGRESS: {
                    draft.menu.isFetching = true;
                    return;
                }

                case ActionTypes.FETCH_MENU_SUCCESS: {
                    draft.menu.isFetching = false;
                    draft.menu.data = payload;
                    return;
                }

                case ActionTypes.FETCH_MENU_FAILED: {
                    draft.menu.isFetching = false;
                    draft.menu.isError = true;
                    return;
                }

                case ActionTypes.FETCH_USER_PROGRESS: {
                    draft.user.isFetching = true;
                    return;
                }

                case ActionTypes.FETCH_USER_SUCCESS:
                case ActionTypes.UPDATE_CUSTOMER_DATA: {
                    draft.user.isFetching = false;
                    const { formKey, customerData, cartCount, base_location } = payload;
                    draft.user.formKey = formKey;
                    draft.user.customerData = customerData;
                    draft.user.cartCount = cartCount;
                    draft.user.base_location = base_location;
                    draft.baseCountry = base_location;
                    return;
                }

                case ActionTypes.UPDATE_CUSTOMER_DETAILS: {
                    const { cartCount, ...rest } = payload;
                    draft.user.customerData = { ...draft.user.customerData, ...rest };
                    draft.user.cartCount = cartCount || draft.user.cartCount;
                    return;
                }

                case ActionTypes.FETCH_USER_FAILED: {
                    draft.user.isFetching = false;
                    draft.user.isError = true;
                    return;
                }

                case ActionTypes.INCREMENT_CART_COUNT:
                case ActionTypes.UPDATE_CART_COUNT: {
                    draft.user.cartCount = payload;
                    return;
                }

                case ActionTypes.SET_RESPONSE_CODE: {
                    draft.statusCode = payload;
                    return;
                }

                case ActionTypes.SET_HEADER_OPTIONS: {
                    draft.headerOptions = {
                        ...draft.headerOptions,
                        ...payload,
                    };
                    return;
                }

                case ActionTypes.RESET_HEADER_OPTIONS: {
                    draft.headerOptions = {
                        ...initialHeaderState,
                    };
                    return;
                }

                case ActionTypes.SET_IN_PROGRESS: {
                    draft.inProgress = payload;
                    return;
                }

                case ActionTypes.SET_HEADER_VISIBILITY: {
                    draft.showHeader = payload;
                    return;
                }

                case ActionTypes.SET_WEB_APP_TYPE: {
                    draft.webAppType = payload;
                    return;
                }

                case ActionTypes.SHOW_LOGIN_OPTIONS: {
                    draft.showLoginOption = payload;
                    return;
                }
                case ActionTypes.SET_APP_SEARCH_TERM: {
                    draft.searchTerm = payload;
                    return;
                }

                case ActionTypes.REDIRECT: {
                    draft.redirectURL = payload;
                    return;
                }
            }
        });
};

export default connectApp;
